import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IncrementalDeliveryProtocol_V0_1_instance;
var IncrementalDeliveryProtocol_V0_2_instance;
var IncrementalDeliveryProtocol_entriesInitialized;
function IncrementalDeliveryProtocol_initEntries() {
  if (IncrementalDeliveryProtocol_entriesInitialized)
    return Unit_instance;
  IncrementalDeliveryProtocol_entriesInitialized = true;
  IncrementalDeliveryProtocol_V0_1_instance = new (IncrementalDeliveryProtocol())('V0_1', 0);
  IncrementalDeliveryProtocol_V0_2_instance = new (IncrementalDeliveryProtocol())('V0_2', 1);
}
var IncrementalDeliveryProtocolClass;
function IncrementalDeliveryProtocol() {
  if (IncrementalDeliveryProtocolClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'IncrementalDeliveryProtocol');
    IncrementalDeliveryProtocolClass = $;
  }
  return IncrementalDeliveryProtocolClass;
}
function IncrementalDeliveryProtocol_V0_1_getInstance() {
  IncrementalDeliveryProtocol_initEntries();
  return IncrementalDeliveryProtocol_V0_1_instance;
}
//region block: exports
export {
  IncrementalDeliveryProtocol_V0_1_getInstance as IncrementalDeliveryProtocol_V0_1_getInstance6abcr423wmp1,
};
//endregion

//# sourceMappingURL=IncrementalDeliveryProtocol.mjs.map
